import { render, staticRenderFns } from "./TripsEdit.vue?vue&type=template&id=70294103&scoped=true"
import script from "./TripsEdit.vue?vue&type=script&lang=ts"
export * from "./TripsEdit.vue?vue&type=script&lang=ts"
import style0 from "./TripsEdit.vue?vue&type=style&index=0&id=70294103&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70294103",
  null
  
)

export default component.exports